// extracted by mini-css-extract-plugin
module.exports = {"message":"WarningGroup_message__1e0WD"};